
import { EcCountry } from "../classes/country";
import { UserRole, ServiceType, SavedFormIdentifier, Modules, ModeTransport } from "./enumeration";
import { environment } from "../../environments/environment";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct";
import { SerializationHelper } from "./serializationHelper";
import { NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";
import { EbEtablissement } from "../classes/etablissement";


export class Statique {

    private static urlBackEnd: String = environment.apiUrl;
    public static path: String = environment.apiUrl;
    // ----------------------- Url Controllers-------------------------------- //
    public static controllerCommunity: string = "api/community";
    public static controllerComplianceMatrix: string = "api/compliance-matrix";
    static AUTH_TOKEN = environment.production ? Statique.urlBackEnd + "/auth" : "/auth";

    public static hideSideBar: boolean;
    public static controllerExpedition: string = "api/expedition"
    public static controllerPricing: string = "api/pricing";
    public static controllerQualityManagement: string = "api/quality-management";
    public static controllerAccount: string = "/api/account";
    public static controllerInscription: string = "/api/inscription";
    public static controllerStatiqueListe: string = "/api/list";
    public static controllerEtablissement: string = "/api/etablissement";
    public static controllerCategorie: string = "/api/categorie";
    public static controllerExport: string = "/api/export";
    public static controllerSavedForm: string = "/api/savedform";
    public static controllerCompagnie: string = "/api/compagnie";
    public static controllerFreightAudit: string = "/api/freight-audit";
    public static controllerTrackTrace: string = "/api/track-trace";
    public static dataSourceFavoris: string = "api/account";

    public static controllerMotif: string = "api/motif";
    // ------------------------------------------------------------------------//
    public static listJours: Map<number, String> = new Map([[1, "Mon."], [2, "Tue."], [3, "Wed."], [4, "Thu."], [5, "Fri."], [6, "Sat."], [7, "Sun."]]);
    public static civilite = ['Mr', 'Mme'];
    public static yesOrNo: keyValue[] = [{ key: true, value: "Yes" }, { key: false, value: "No" }];
    public static delaiRange: number[] = [1, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24];
    public static patternTime: string = "([01]?[0-9]|2[0-3]):[0-5][0-9]";
    public static maskTime: Array<string | RegExp> = [/\d/, /\d/, ':', /\d/, /\d/];
    public static patternSIRET: string = "[0-9]{14}";
    public static maskSIRET: Array<string | RegExp> = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    public static patternPhone: string = "";
    public static maskPhone: Array<string | RegExp> = [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
    public static patterEmail: string = "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?";
    public static patternIBAN: string = "FR[0-9]{2}[0-9]{5}[0-9]{5}[A-Z0-9]{11}[0-9]{2}";
    public static maskIBAN: Array<string | RegExp> = [/[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/];
    public static patternNumber: string = "[1-9][0-9]*";
    public static patternDecimalNumber: string = "[0-9]+(\.[0-9]*)?";
    public static days = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
    public static months = ["Janv", "Févr", "Mars", "Avril", "Mai", "Juin", "Juil", "Août", "Sept", "Oct", "Nov", "Déc"];
    public static $5MbToBytes: number = 5324800;
    public static listEtatHoraire: keyValue[] = [{ key: 0, value: "All Days" }, { key: 1, value: "Customise" }];
    public static daysEnum = ["ALL", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
    public static patternSIREN: string = "[0-9]{9}";
    public static maskSIREN: Array<string | RegExp> = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    public static patternNIC: string = "[0-9]{5}";
    public static maskNIC: Array<string | RegExp> = [/\d/, /\d/, /\d/, /\d/, /\d/];
    public static roleUser: string[] = ['Chargeur', 'Prestataire', 'Control Tower'];
    public static Service_Type: string[] = ['Carrier', 'Broker', 'Carrier / Broker'];
    public static etatRelation: string[] = ["Actif", "Blacklist"];
    public static $1MbToBytes: number = 1048576;
    public static typeDemande: keyValue[] = [{ key: 1, value: "Standard" }, { key: 2, value: "Urgent" }];
    public static modeTransport: keyValue[] = [{ key: 40, value: "AERIEN" }, { key: 10, value: "MARITIME" }];//, { key: 3, value: "Road" }, { key: 4, value: "Integrator" }
    public static incoterms: keyValue[] = [{ key: 1, value: "DDP" }, { key: 2, value: "DAP" }, { key: 3, value: "DAT" }, { key: 4, value: "CIP" }, { key: 5, value: "CPT" }, { key: 6, value: "CIF" }, { key: 7, value: "CFR" }, { key: 8, value: "FOB" }, { key: 9, value: "FAS" }, { key: 10, value: "FCA" }, { key: 11, value: "EXW" }];
    public static TypeTransportAir: keyValue[] = [{ key: 1, value: "Consolidation" }, { key: 2, value: "Direct" }];
    public static TypeTransportSea: keyValue[] = [{ key: 1, value: "LCL" }, { key: 2, value: "FCL" }];
    public static TypeTransportRoad: keyValue[] = [{ key: 1, value: "Consolidation" }, { key: 2, value: "Dedicated" }];
    public static TypeTransportIintegrateur: keyValue[] = [{ key: 1, value: "Consolidation" }, { key: 2, value: "Dedicated" }, { key: 3, value: "LCL" }, { key: 4, value: "FCL" }, { key: 5, value: "Direct" }];

    public static YEAR_MONTH_DAY_PATHERN = "yyyy-MM-dd";

    public static TtPsl: keyValue[] = [
        { key: 1, value: "Ramassage", codeAlpha: "RAM" },
        { key: 2, value: "Réception", codeAlpha: "REC" },
        { key: 3, value: "Départ", codeAlpha: "DEP" },
        { key: 4, value: "Arrivée", codeAlpha: "ARR" },
        { key: 5, value: "Douane", codeAlpha: "DOU" },
        { key: 6, value: "Livraison", codeAlpha: "LIV" }
    ];
    public static TtDeviationCategorie: keyValue[] = [
        { key: 1, value: "Missing or damaged goods" },
        { key: 2, value: "Information flow issues" },
        { key: 3, value: "Operational issues" },
        { key: 4, value: "Other issues" },
        { key: 5, value: "Customs issue" },
        { key: 6, value: "Goods availibility issues" },
        { key: 7, value: "Hazardous goods issues" },
        { key: 8, value: "Force majeure" },
        { key: 9, value: "Cold chain issues" }
    ];
    public static TypeTransport: TypeTransportkeyValue[] = [{ key: 1, value: ["Consolidation", 1] }, { key: 2, value: ["Direct", 2] }, { key: 3, value: ["LCL", 1] }, { key: 4, value: ["FCL", 2] }, { key: 5, value: ["Consolidation", 1] }, { key: 6, value: ["Dedicated", 2] }];

    public static patternPassword: string = "(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$";

    // public static MarchandiseTypeOfUnit: keyValue[] = [
    //     { key: 1, value: "Cardboard box" },
    //     { key: 2, value: "Pallet" },
    //     { key: 3, value: "Crate" },
    //     { key: 4, value: "Case" },
    //     { key: 5, value: "Bundle" },
    //     { key: 6, value: "Barrel" },
    //     { key: 7, value: "Container 20' x 8'6' Dry" },
    //     { key: 8, value: "Container 20' x 9'6' Dry High Cube" },
    //     { key: 9, value: "Container 20' x 8'6' Reefer" },
    //     { key: 10, value: "Container 20' x 9'6' Reefer High Cube" },
    //     { key: 11, value: "Container 20' Open Top" },
    //     { key: 12, value: "Container 20' Hard Top" },
    //     { key: 13, value: "Container 20' Flat Rack" },
    //     { key: 14, value: "Container 40'x8'6' Dry" },
    //     { key: 15, value: "Container 40'x9'6' Dry High Cube" },
    //     { key: 16, value: "Container 40'x8'6' Reefer" },
    //     { key: 17, value: "Container 40'x9'6' Reefer High Cube" },
    //     { key: 18, value: "Container 40' Open Top" },
    //     { key: 19, value: "Container 40' Hard Top" },
    //     { key: 20, value: "Container 40' Flat Rack" },
    //     { key: 21, value: "Container 45'x9'6' Dry High Cube" },
    //     { key: 22, value: "Container 45'x9'6' Reefer High Cube" },
    // ];
    public static MarchandiseTypeOfUnit: keyValue[] = [
        { key: 23, value: "Concentrés de Plaquettes (CP)" },
        { key: 23, value: "Plaquettes congelées" },
        { key: 24, value: "Concentré de Globules Rouges (CGR)" },
        { key: 25, value: "Plasma Frais Congelé (PFC)" },
        { key: 26, value: "Cellules Souches Hématopoïétiques (CSH)" },
        { key: 27, value: "Tubes Echantillons" },
        { key: 28, value: "Tubes Echantillons congelés" },
        { key: 29, value: "Réactifs" },
        { key: 30, value: "Réactifs congelés" },
        { key: 31, value: "Consommables" }

    ];

    public static MarchandiseDangerousGood: keyValue[] = [{ key: 1, value: "No" }, { key: 2, value: "OK PAX" }, { key: 3, value: "CAO" }];

    public static pathToFiles: String = Statique.path.toString().concat('/');

    public static StatutDemande: keyValue[] = [

        { value: "IN_PROCESS_WAITING_FOR_QUOTE", key: 1, codeAlpha: "" },
        { value: "WAITING_FOR_RECOMMENDATION", key: 2, codeAlpha: "" },
        { value: "WAITING_FOR_CONFIRMATION", key: 3, codeAlpha: "Pre confirmé" },
        { value: "CONFIRMED", key: 4, codeAlpha: "Confirmé" },

        { value: "NOT_AWARDED", key: 5, codeAlpha: "" },
        { value: "CANCELLATION_OF_QUOTATION_REQUEST", key: 6, codeAlpha: "Annulé" },
        { value: "ARCHIVED ", key: 7, codeAlpha: "" },

        { value: "Prebooking cancelled ", key: 8, codeAlpha: "" },
        { value: "Waiting for cancellation confirmation ", key: 9, codeAlpha: "" },

        { value: "WAITING_DOCUMENT_TRANSPORT_CUSTOMS", key: 10, codeAlpha: "" },
        { value: "WAITING_DOCUMENT_CUSTOMS", key: 101, codeAlpha: "" },
        { value: "WAITING_DOCUMENT_TRANSPORT", key: 102, codeAlpha: "" },
        { value: "WAITING_PICKUP", key: 11, codeAlpha: "En attente d'enlèvement" },
        { value: "TRANSPORT_ONGOING", key: 12, codeAlpha: "" },

        { value: "Completed", key: 13, codeAlpha: "" },
        { value: "Waiting for transportation request ", key: 16, codeAlpha: "" }

    ];

    public static EtatCommande: keyValue[] = [

        { value: "En attente d'enlèvement", key: 20, codeAlpha: "En attente d'enlèvement" },
        { value: "Enlèvement", key: 21, codeAlpha: "Enlèvement" },
        { value: "Reception", key: 22, codeAlpha: "Reception" },
        { value: "Départ", key: 23, codeAlpha: "Départ" },
        { value: "Douane", key: 24, codeAlpha: "Douane" },
        { value: "Arrivé", key: 25, codeAlpha: "Arrivé" },
        { value: "Livraison finale", key: 26, codeAlpha: "Livraison finale" }


    ];

    public static CarrierStatus: keyValue[] = [
        { key: 1, value: "Request received by FF" }, // FF = Freight Forwarder
        { key: 2, value: "Quote sent by FF" },
        { key: 3, value: "Recommendation by CT" },
        { key: 4, value: "Final choice" },
        { key: 4, value: "Not awarded" }
    ];
    public static InvoiceStatus: keyValue[] = [
        { key: 1, value: "Waiting For Carrier Input" },
        { key: 2, value: "Waiting For Chargeur Confirmation" },
        { key: 3, value: "Waiting For Carrier Confirmation" },
        { key: 4, value: "Confirmed By Chargeur" }
    ];
    public static Flag: keyValue[] = [
        { key: 0, value: " " },
        { key: 1, value: "V" },
        { key: 2, value: "X" },
        { key: 3, value: "?" },
        { key: 4, value: "!" }
    ];

    public static getEtatCommandeByKey(_key): String {
        let toReturn = ' ';
        let cpt = 0;
        Statique.EtatCommande.forEach(element => {
            cpt++;
            if (element.key == _key) {
                toReturn = element.codeAlpha;
            }
        });
        if (cpt == Statique.EtatCommande.length) {
            return toReturn;
        }


    }
    public static getStatutDemandByKey(_key): String {
        let toReturn = '';
        let cpt = 0;
        Statique.StatutDemande.forEach(element => {
            cpt++;
            if (element.key == _key) {
                toReturn = element.codeAlpha;
            }
        });
        if (cpt == Statique.StatutDemande.length) {
            return toReturn;
        }


    }
    public static TypeDemandeTimeRemaining = {
        1: 48 * 3600000,
        2: 24 * 3600000,
    };

    public static OriginCustomsBroker: keyValue[] = [
        { key: 1, value: "MyTower operation" },
        { key: 2, value: "Carrier" },
        { key: 3, value: "Not applicable" }
    ];

    public static iconsPath: string = "assets/images/pictos/pictos-metier/";
    public static moduleIcon = {
        PRICING: "pricing.svg",
        TRANSPORT_MANAGEMENT: "trans-manag.svg",
        TRACK: "track-trace.svg",
        QUALITY_MANAGEMENT: "qualite-manag.svg",
        FREIGHT_AUDIT: "freight-audit.svg",

        COMPLIANCE_MATRIX: "freight-audit.svg",
    };
    public static moduleNamePath = {
        PRICING: "pricing",
        TRANSPORT_MANAGEMENT: "transport-management",
        TRACK: "track-trace",
        CLAIMS: "claims",
        FREIGHT_AUDIT: "freight-audit",
        FREIGHT_ANALYTICS: "freight-analytics",
        COMPLIANCE_MATRIX: "compilance-matrix",
        pricingMask: "pricing/creation",
    };

    public static moduleDetailsPath = {
        PRICING: "details",
        TRANSPORT_MANAGEMENT: "details",
        TRACK: "details",
        CLAIMS: "",
        FREIGHT_AUDIT: "details",
        FREIGHT_ANALYTICS: "",
        COMPLIANCE_MATRIX: "",
    };

    public static invoiceMonths: keyValue[] = [
        { key: 1, value: "Jan" },
        { key: 2, value: "Fev" },
        { key: 3, value: "Mars" },
        { key: 4, value: "Avril" },
        { key: 5, value: "Mai" },
        { key: 6, value: "Juin" },
        { key: 7, value: "Juil." },
        { key: 8, value: "Aout" },
        { key: 9, value: "Sept." },
        { key: 10, value: "Oct" },
        { key: 11, value: "Nov" },
        { key: 12, value: "Dec" }
    ];

    public static Year: keyValue[] = [
        { key: 1, value: "2017" },
        { key: 2, value: "2018" },
        { key: 3, value: "2019" },
        { key: 4, value: "2020" },
        { key: 5, value: "2021" },
        { key: 6, value: "2022" }
    ];

    public static getModuleNameByModuleNum(ebModuleNum) {
        switch (ebModuleNum) {
            case Modules.PRICING: return "PRICING";
            case Modules.TRANSPORT_MANAGEMENT: return "TRANSPORT_MANAGEMENT";
            case Modules.QUALITY_MANAGEMENT: return "QUALITY_MANAGEMENT";
            case Modules.TRACK: return "TRACK";
            case Modules.FREIGHT_AUDIT: return "FREIGHT_AUDIT";
            case Modules.FREIGHT_ANALYTICS: return "FREIGHT_ANALYTICS";

            case Modules.COMPLIANCE_MATRIX: return "COMPLIANCE_MATRIX";
            case Modules.ETATAQUAI: return "PRICING";
        }
    }

    public static getComponentPathByCompIdAndModuleId(compId, moduleId): string {
        switch (moduleId) {
            case Modules.PRICING:
                if (compId === SavedFormIdentifier.PRICING_MASK)
                    return Statique.moduleNamePath.pricingMask;
                if (compId === SavedFormIdentifier.SAVED_SEARCH)
                    return Statique.moduleNamePath[Statique.getModuleNameByModuleNum(moduleId)];
            default:
                return
        }
    }

    public static getComponentPathByModuleId(moduleId): string {
        return Statique.moduleNamePath[Statique.getModuleNameByModuleNum(moduleId)] + "/" + Statique.moduleDetailsPath[Statique.getModuleNameByModuleNum(moduleId)];
    }

    public static getModuleNumFromUrl(url: string): number {
        let moduleName = Statique.getModuleNameFromUrl(url);
        if (moduleName)
            return Statique.getModuleNumByModuleName(moduleName);
        return null;
    }
    public static getModuleNumByModuleName(moduleName: string): number {
        let moduleNum = null;

        Object.keys(Statique.moduleNamePath).some(mod => {
            if (mod == moduleName && Modules[mod]) {
                moduleNum = Number(Modules[mod]);
                return true;
            }
        });

        return moduleNum;
    }
    public static getModuleNameFromUrl(url: string): string {
        let moduleName = Statique.getPathFromUrl(url);

        Object.keys(this.moduleNamePath).some(it => {
            if (url.indexOf(this.moduleNamePath[it]) >= 0) {
                moduleName = it;
                return true;
            }
        });

        if (Statique.moduleNamePath[moduleName])
            return moduleName;

        return null;
    }

    public static getPathFromUrl(url) {
        let path = url.replace(/^[a-z]{4}\:\/{2}[a-z]{1,}\:[0-9]{1,4}.(.*)/, '$1');
        if (path[path.length - 1] == "/")
            return path.substring(0, path.length - 1);
        return path;
    }

    public static isDefined(obj: any): boolean {
        return (obj != null && obj != undefined);
    }

    public static validateNumber(event: any) {
        return (event.charCode >= 48 && event.charCode <= 57);
    }

    public static formatDatewithHours(date: any) {
        let dt = new Date(date);
        return this.formatDate(dt) + " " + dt.getHours() + ":" + dt.getMinutes();

    }

    public static formatDate(date: any) {
        if (date) {
            date = this.stringToDate(date);
            let curr_day = date.getDate() ;
            let curr_month = date.getMonth() + 1; //Months are zero based
            let curr_year = date.getFullYear();
            let day = curr_day <= 9 ? "0" + curr_day : curr_day;
            let month = curr_month <= 9 ? "0" + curr_month : curr_month;


            return day + "/" + month + "/" + curr_year;
        }
        else {
            return null;
        }
    }

    public static stringToDate(date) {
        if (date == null) {
            return null
        }
        else if (typeof date == "object") {
            return date;
        }
        else {
            let pattern = null;
            let strDate = null;

            if ((pattern = /(\d{2})\/(\d{2})\/(\d{4})/).test(date))
                strDate = date.replace(pattern, '$3-$2-$1');
            else strDate = date;

            return new Date(strDate);
        }
    }

    public static convertToUTC(date: Date){
        if (!date) {
          return null;
        }
        date = new Date(date);
        var offset = date.getTimezoneOffset();
        date.setMinutes(offset);
        return date;
    }

    public static equalsObject(obj1: any, obj2: any) {
        return (JSON.stringify(obj1) === JSON.stringify(obj2));
    }

    public static byEcCountryNum(obj1: EcCountry, obj2: EcCountry) {
        if ((obj1 != undefined && obj2 != undefined) && (obj1 != null && obj2 != null)) {
            return obj1.ecCountryNum == obj2.ecCountryNum;
        }
        else return false;
    }

    public static byEbEtablissementNum(obj1: EbEtablissement, obj2: EbEtablissement) {
        if ((obj1 != undefined && obj2 != undefined) && (obj1 != null && obj2 != null)) {
            return obj1.ebEtablissementNum == obj2.ebEtablissementNum;
        }
        else return false;
    }

    public static getStyleServiceType(role: number) {
        let _class = '';
        if (role == ServiceType.TRANSPORTEUR) _class = "label label-primary";
        else if (role == ServiceType.BROKER) _class = "label label-primary";
        else if (role == ServiceType.TRANSPORTEUR_BROKER) _class = "label label-primary";
        return _class;
    }

    public static formatDateFromDatePicker(date) {
        return date ? this.formatDate(new Date(date.year, date.month - 1, date.day)) : null;
    }

    public static fromDatePicker(date) {
        return date ? new Date(date.year, date.month - 1, date.day) : null;
    }

    public static getDateFromDatetime(dt): Date {
        let date = null;
        if (dt) date = new Date(dt);
        else return null;
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    public static formatDateToStructure(dt): NgbDateStruct {
        let date = null;
        if (dt) date = new Date(dt);
        else return { day: null, month: null, year: null };
        return { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() };
    }
    public static formatStrTimeToStructure(textTime): NgbTimeStruct {
        let obj = { hour: null, minute: null, second: null };
        if (!textTime)
            return obj;

        let arrTime = textTime.split(":");
        if (arrTime.length >= 2) {
            return { hour: arrTime[0], minute: arrTime[1], second: 0 };
        }

        return obj;
    }
    public static formatTimeToStructure(dt): NgbTimeStruct {
        let date = null;
        if (dt) date = new Date(dt);
        else return { hour: null, minute: null, second: null };
        return { hour: date.getHours(), minute: date.getMinutes(), second: date.getSeconds() };
    }
    public static formatDateTime(date: Date, time: NgbTimeStruct) {
        if (!date)
            return null;
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);

        if (time) {
            date.setHours(time.hour);
            date.setMinutes(time.minute);
            date.setSeconds(time.second);
        }

        return date;
    }

    public static removeNullList(DataJson: any) {

        for (var propName in DataJson) {
            if (DataJson[propName] === null || DataJson[propName] === undefined) {
                delete DataJson[propName];
            }
        }

        return DataJson;
    }

    public static formatMillisToObject(milliseconds: number, ignoreDays = false) {
        //Get hours from milliseconds
        var days = milliseconds / (1000 * 60 * 60 * 24);
        var absoluteDays = Math.floor(days);

        var hours = days > 0 ? (days - absoluteDays) * 24 : milliseconds / (1000 * 60 * 60);
        var absoluteHours = Math.floor(hours);

        //Get remainder from hours and convert to minutes
        var minutes = hours > 0 ? (hours - absoluteHours) * 60 : milliseconds / (1000 * 60);
        var absoluteMinutes = Math.floor(minutes);

        //Get remainder from minutes and convert to seconds
        var seconds = minutes > 0 ? (minutes - absoluteMinutes) * 60 : milliseconds / 1000;
        var absoluteSeconds = Math.floor(seconds);

        return {
            days: Statique.lpad(absoluteDays),
            hours: Statique.lpad(absoluteHours + (ignoreDays ? absoluteDays * 24 : 0)),
            minutes: Statique.lpad(absoluteMinutes),
            seconds: Statique.lpad(absoluteSeconds)
        };
    }

    public static getDays(t) {
        var days;
        days = Math.floor(t / (24 * 60 * 60));

        return this.format2numbers(days);
    }

    public static getHours(t) {
        var days, hours;
        days = Math.floor(t / (24 * 60 * 60));
        t -= days * (24 * 60 * 60);
        hours = Math.floor(t / (60 * 60)) % 24;

        return this.format2numbers(hours);
    }

    public static getMinutes(t) {
        var days, hours, minutes;
        days = Math.floor(t / (24 * 60 * 60));
        t -= days * (24 * 60 * 60);
        hours = Math.floor(t / (60 * 60)) % 24;
        t -= hours * (60 * 60);
        minutes = Math.floor(t / 60) % 60;

        return this.format2numbers(minutes);
    }

    public static getUrlFile(path: String): String {
        if (path != null) {
            return this.pathToFiles.concat(path.toString().replace('\\', '/'));
        }
        else return path;
    }

    public static getSeconds(t) {
        var days, hours, minutes, seconds;
        days = Math.floor(t / 86400);
        t -= days * 86400;
        hours = Math.floor(t / 3600) % 24;
        t -= hours * 3600;
        minutes = Math.floor(t / 60) % 60;
        t -= minutes * 60;
        seconds = t % 60;

        return this.format2numbers(seconds);
    }

    public static format2numbers(number) {

        return number > 9 ? number : "0" + number;
    }

    public static planify(data) {
        for (var i = 0; i < data.order.length; i++) {
            let order = data.order[i];
            let column = data.columns[order.column];
            order.columnName = column.data;
        }
        for (var i = 0; i < data.columns.length; i++) {
            /* let column = data.columns[i];
             column.searchRegex = column.search.regex;
             column.searchValue = column.search.value;
             column = data.columns[i];
             delete (column.search);*/
            delete (data.columns[i]);
        }
    }

    public static copyObject(obj: object, includeObjects: boolean = false) {
        let newObj = {};

        if (obj && typeof obj === "object") {
            Object.keys(obj).forEach(it => {
                if (typeof obj[it] !== "object" || includeObjects)
                    newObj[it] = obj[it];
            });
        }

        return newObj;
    }

    public static isNotDefined(data): boolean {
        return data === null || typeof data === "undefined" || (typeof data === "string" && data.trim().length == 0);
    }

    public static cloneObject<T>(obj: any, type?: T) {
        try {
            if (type != undefined) return SerializationHelper.toInstance(type, JSON.stringify(obj));
            else return JSON.parse(JSON.stringify(obj));
        }
        catch (e) {
            console.log("cannot parse object");
        }

        return null;
    }

    public static truncate2Decimal(value: number) {
        return (Math.trunc(value * 100) / 100);
    }

    public static lpad(str, padString = "0", length = 2) {
        str = "" + str;
        while (str.length < length)
            str = padString + str;
        return str;
    }

    public static getValue(list: any, key: any) {
        return list.find(item => item.key == key).value;
    }

    public static getTypeTransport(modetransport: any, key: any) {
        if (ModeTransport.AIR == modetransport) {
            return this.getValue(this.TypeTransportAir, key);
        }
        else if (ModeTransport.ROAD == modetransport) {
            return this.getValue(this.TypeTransportRoad, key);
        }
        else if (ModeTransport.SEA == modetransport) {
            return this.getValue(this.TypeTransportSea, key);
        }
    }

    public static waitForTimemout(millis: number = 500) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(millis);
            }, millis)
        });
    }

    public static convertNewlines(value: string): any {
        if (value == null)
            return "";
        return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }

    public static overlapTwoDateRanges(startA: Date, endA: Date, startB: Date, endB: Date) {
        return (startA.getTime() <= endB.getTime()) && (endA.getTime() >= startB.getTime());
    }

    public static moveDomElement(el, container) {
        let oldParent = el.parentNode;
        // let lastChild = container.children[0];
        container.insertBefore(el, null);
        // oldParent.removeChild(el);
    }

    public static findAncestor(el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }

    public static isEmptyObject(obj) {
        let key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) return false;
        }
        return true;
    };

    public static async waitUntilElementExists(eltQuery: string, firstElt = true, timeout: number = 500) {
        if (!eltQuery) throw Error("No element query provided");

        let totalTimeout = 0;
        let el;
        while (!(el = document.querySelectorAll(eltQuery)[0]) && totalTimeout < 15000) {
            totalTimeout += timeout;
            await Statique.waitForTimemout(timeout);
        }

        if (!el)
            throw Error("Element not loaded/found in the dom for 15s");

        if (!firstElt)
            el = document.querySelectorAll(eltQuery);

        return el;
    }

    public static triggerEvent(evt: string) {
        var event = new Event(evt);
        document.dispatchEvent(event);
    }

    public static getIncotermValueBykey(_key): String {
        let toReturn = '';
        let cpt = 0;
        Statique.incoterms.forEach(element => {
            cpt++;
            if (element.key == _key) {
                toReturn = element.value;
            }
        });
        if (cpt == Statique.incoterms.length) {
            return toReturn;
        }
    }

    public static keyPressSaufCharacter(event: any) {
        const pattern = /([a-zA-Z\s])/;
        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }

    }

    public static getCookie(name: string): string {
		const nameLenPlus = name.length + 1;
		return (
			document.cookie
				.split(";")
				.map((c) => c.trim())
				.filter((cookie) => {
					return cookie.substring(0, nameLenPlus) === `${name}=`;
				})
				.map((cookie) => {
					return decodeURIComponent(cookie.substring(nameLenPlus));
				})[0] || null
		);
	}

    public static getDeffaultParamCommande(): any {
        return JSON.parse('{\n' +
            '    "requiredFieldsInfos_Com": {\n' +
            '        "commandeNum": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": true,\n' +
            '            "value": "N° de Commande"\n' +
            '        },\n' +
            '        "dateCommande": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": true,\n' +
            '            "value": "Date Commande"\n' +
            '        },\n' +
            '        "xEcModeTransport": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": true,\n' +
            '            "value": "Mode de transport"\n' +
            '        },\n' +
            '        "ecCurrencyNum": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": true,\n' +
            '            "value": "Devise de la facture"\n' +
            '        },\n' +
            '        "instruction": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Instructions"\n' +
            '        },\n' +
            '        "refTransport": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Favori"\n' +
            '        },\n' +
            '        "xEbAgence": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": true,\n' +
            '            "value": "Agence"\n' +
            '        },\n' +
            '        "infoPartyOri": {\n' +
            '            "company": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Entité"\n' +
            '            },\n' +
            '            "efsServices": {\n' +
            '                "isLisible": false,\n' +
            '                "isRequired": false,\n' +
            '                "value": "Services"\n' +
            '            },\n' +
            '            "adresse": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Adresse"\n' +
            '            },\n' +
            '            "city": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Ville"\n' +
            '            },\n' +
            '            "zipCode": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Code postal"\n' +
            '            },\n' +
            '            "xEcCountry": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Pays"\n' +
            '            },\n' +
            '            "airport": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": false,\n' +
            '                "value": "Aéroport"\n' +
            '            },\n' +
            '            "phone": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": false,\n' +
            '                "value": "Coordonnées"\n' +
            '            },\n' +
            '            "heureEnlevement": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": false,\n' +
            '                "value": "Heure d\'enlèvement"\n' +
            '            }\n' +
            '        },\n' +
            '        "infoPartyExp": {\n' +
            '            "company": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Entité"\n' +
            '            },\n' +
            '            "efsServices": {\n' +
            '                "isLisible": false,\n' +
            '                "isRequired": false,\n' +
            '                "value": "Services"\n' +
            '            },\n' +
            '            "adresse": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Adresse"\n' +
            '            },\n' +
            '            "city": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Ville"\n' +
            '            },\n' +
            '            "zipCode": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Code postal"\n' +
            '            },\n' +
            '            "xEcCountry": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Pays"\n' +
            '            },\n' +
            '            "airport": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": false,\n' +
            '                "value": "Aéroport"\n' +
            '            },\n' +
            '            "phone": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": false,\n' +
            '                "value": "Coordonnées"\n' +
            '            },\n' +
            '            "heureEnlevement": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": false,\n' +
            '                "value":"Heure d\'enlèvement"\n' +
            '            }\n' +
            '        },\n' +
            '        "infoPartyDes": {\n' +
            '            "company": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Entité"\n' +
            '            },\n' +
            '            "efsServices": {\n' +
            '                "isLisible": false,\n' +
            '                "isRequired": false,\n' +
            '                "value": "Services"\n' +
            '            },\n' +
            '            "adresse": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Adresse"\n' +
            '            },\n' +
            '            "city": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Ville"\n' +
            '            },\n' +
            '            "zipCode": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Code postal"\n' +
            '            },\n' +
            '            "xEcCountry": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": true,\n' +
            '                "value": "Pays"\n' +
            '            },\n' +
            '            "airport": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": false,\n' +
            '                "value": "Aéroport"\n' +
            '            },\n' +
            '            "phone": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": false,\n' +
            '                "value": "Coordonnées"\n' +
            '            },\n' +
            '            "heureEnlevement": {\n' +
            '                "isLisible": true,\n' +
            '                "isRequired": false,\n' +
            '                "value":"Heure d\'enlèvement"\n' +
            '            }\n' +
            '        },\n' +
            '        "commandeNumScenario1": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": true,\n' +
            '            "value": "Référence"\n' +
            '        }\n' +
            '    },\n' +
            '    "requiredFieldsProduit": {\n' +
            '        "typeMarchandise": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Type de produit"\n' +
            '        },\n' +
            '        "numberOfUnits": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value":"Nombre d\'unités"\n' +
            '        },\n' +
            '        "volume": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Volume (m3)"\n' +
            '        },\n' +
            '        "nbrPalette": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Nombre de palette"\n' +
            '        },\n' +
            '        "temperature": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Température"\n' +
            '        },\n' +
            '        "lotNum": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "N° Lot"\n' +
            '        },\n' +
            '        "dangerous": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Dangereux"\n' +
            '        },\n' +
            '        "dateDispo": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Date disponibilité/enlèvement"\n' +
            '        },\n' +
            '        "montantHT": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Montant HT (€)"\n' +
            '        },\n' +
            '        "comment": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Commentaires"\n' +
            '        },\n' +
            '        "numReception": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Numéro réception"\n' +
            '        },\n' +
            '        "facture": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Facture"\n' +
            '        },\n' +
            '        "numFacture": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Valeur facture"\n' +
            '        },\n' +
            '        "weight": {\n' +
            '            "isLisible": true,\n' +
            '            "isRequired": false,\n' +
            '            "value": "Poids (kg)"\n' +
            '        }\n' +
            '    }\n' +
            '}');
    }
}

export interface keyValue {
    key: any;
    value: string;
    codeAlpha?: string;
}

export interface TypeTransportkeyValue {
    key: any;
    value: any;
}

export interface idText {
    id: number;
    text: String;
}





// WEBPACK FOOTER //
// ./src/app/utils/statique.ts